<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        @click="add()"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        
        @click="open()"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        
        @click="getRoleinfo"
      >刷新</el-button>
      <span style="padding: 0 10px">角色名称</span>
      <el-input
        v-model="roleName"
        placeholder="请输入角色名称"
        style="width: 200px; heigth: 30px; line-height: 30px"
        clearable
        @keyup.enter.native="handleSelect"
      />
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="handleSelect"
      >筛选</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 230px )"
      size="mini"
      style="width: 801px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        :selectable="checkSelectable"
      />
      <el-table-column prop="name" label="名称" width="150" />
      <el-table-column prop="description" label="描述" width="200" />
      <el-table-column label="系统旧版本" width="100">
        <template slot-scope="scope">{{
          scope.row.isSystem ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column label="创建时间" show-overflow-tooltip width="180">
        <template slot-scope="scope">{{ scope.row.modifyDate }}</template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
          >
            编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getRoleinfo"
    />

    <!-- 编辑弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="960px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <!-- <span>这是一段信息</span> -->
      <div class="edit_titile">
        <div class="dialog_input">
          <span>角色名称：</span>
          <el-input
            v-model="editinfo.name"
            placeholder="请输入角色名称"
            :disabled="Isedit"
          />
        </div>
        <div style="margin-top: 10px" class="dialog_input">
          <span>角色描述：</span>
          <el-input
            v-model="editinfo.description"
            placeholder="请描述该角色"
            :disabled="Isedit"
          />
        </div>
        <div style="margin-top: 10px" class="dialog_input">
          <span>管理代理商：</span>
          <div style="flex: 1;">
            <el-checkbox-group v-model="checkList">
             <el-checkbox v-for="(item,index) in yifangList" :key="index" :label="item.id">{{ item.username }}</el-checkbox>
          </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 权限表 -->
      <div
        v-for="(item, index) in authority_form"
        :key="index"
        class="authority_info"
      >
        <el-checkbox
          v-model="item.checkAll"
          :indeterminate="item.isIndeterminate"
          @change="handleCheckAllChange(index, item.checkAll)"
        >{{ item.name }}</el-checkbox>
        <div style="margin: 15px 0" />
        <el-checkbox-group
          v-model="item.checkedItem"
          @change="handleCheckedCitiesChange(index, item.checkedItem)"
        >
          <el-checkbox
            v-for="(AU_item, index2) in item.Items"
            :key="index2"
            :label="AU_item"
          >{{ AU_item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 特殊权限表 -->
      <div class="authority_info">
        <el-checkbox
          v-model="permissions_from.checkAll"
          :indeterminate="permissions_from.isIndeterminate"
          @change="SPCheckAllChange(permissions_from.checkAll)"
        >{{ permissions_from.name }}</el-checkbox>
        <div style="margin: 15px 0" />
        <el-checkbox-group
          v-model="permissions_from.checkedItem"
          @change="SPCheckedCitiesChange(permissions_from.checkedItem)"
        >
          <el-checkbox
            v-for="(AU_item, index2) in permissions_from.Items"
            :key="index2"
            :label="AU_item"
          >{{ AU_item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 弹窗脚部 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_dialogVisible = false">取 消</el-button>
        <el-popconfirm title="确定修改吗？" @confirm="updateInfo()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
            style="margin-left: 10px"
            :disabled="disAble"
          >
            确定</el-button>
        </el-popconfirm>
        <!-- <el-button type="primary" @click="updateInfo()">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import { merge } from '@/utils/tool' // 引入数组去重
import { asyncRoutes } from '@/router'
export default {
  name: 'RoleManagement',
  components: { Pagination },
  data() {
    return {
      roleName: '', // 搜索的角色名
      showtabelData: [], // 展示的表单信息
      editinfo: {}, // 修改角色
      yifangList:[],
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // loading
      checkList:[],
      authority_form: [],
      disAble: false,
      permissions_from: {
        name: '特许权限',
        checkAll: false,
        checkedItem: [],
        Items: [
          {
            label: '提现记录批量通过',
            value: 'permission:wrCheckSuccessList'
          },
          {
            label: '提现记录批量拒绝',
            value: 'permission:wrCheckRejectList'
          }
          // {
          //   label: "在线客服",
          //   value: "permission:kefuonline",
          // },
          // {
          //   label: "风险聊天控制",
          //   value: "permission:dangerChat",
          // },
          // {
          //   label: "首页数据统计入口",
          //   value: "permission:indexData",
          // },
        ],
        isIndeterminate: true
      }
    }
  },
  mounted() {
    this.getRoleinfo()
    this.getpermissions()
    this.getYiFangList()
  },
  methods: {
    // 禁止选择
    checkSelectable(row) {
      return row.isSystem == false
    },
    // 获取角色表单信息
    getRoleinfo() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        name: this.roleName
      }
      this.loading = true
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.$api.role
        .getRoleList(params)
        .then((res) => {
          this.showtabelData = res.records
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getYiFangList() {
      this.$api.role
        .yifangList()
        .then((res) => {
          this.yifangList = res
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 角色搜索
    handleSelect() {
      if (this.roleName == '') {
        return this.$message.error('请输入搜索的角色名')
      }
      this.pageNum = 1
      this.getRoleinfo()
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //   关闭弹窗
    handleClose() {
      this.editinfo = {}
      for (let i = 0; i < this.authority_form.length; i++) {
        this.authority_form[i].checkedItem = []
        this.authority_form[i].checkAll = false
      }
      this.permissions_from.checkedItem = []
    },
    // 删除选中项
    handleDel() {
      var arr = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        arr.push(this.multipleSelection[i].id)
      }
      var params = {
        ids: arr.toString()
      }
      this.$api.role
        .DelRole(params)
        .then((res) => {
          this.$message.success(res)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.getRoleinfo()
        })
    },
    // 打开编辑弹窗
    edit(row) {
      console.log(row)
      var authority = row.authorities
      
      var length = this.authority_form.length
      var AuFrom = this.authority_form
      // 判断是否超级管理员
      if (authority.includes('admin:*')) {
        this.authority_form.forEach((item) => {
          item.checkedItem = item.Items
          item.checkAll = true
        })
        this.disAble = true
      } else {
        this.disAble = false
        // console.log("authority",authority)
        for (let l = 0; l < length; l++) {
          for (let i = 0; i < authority.length; i++) {
            const index = AuFrom[l].Items.findIndex(
              (item) => item.value == authority[i]
            )
            if (index != -1) {
              // AuFrom[l].checkedItem.push(authority[i]);
              AuFrom[l].checkedItem.push(AuFrom[l].Items[index])
              if (AuFrom[l].checkedItem.length == AuFrom[l].Items.length) {
                AuFrom[l].checkAll = true
              }
            }
          }
        }
      }
      if (row.permissions) {
        row.permissions.forEach((item) => {
          var permissionsindex = this.permissions_from.Items.findIndex(
            (item2) => item2.value == item
          )
          if (permissionsindex != -1) {
            this.permissions_from.checkedItem.push(
              this.permissions_from.Items[permissionsindex]
            )
          }
          if (
            this.permissions_from.checkedItem.length ==
            this.permissions_from.Items.length
          ) {
            this.permissions_from.checkAll = true
          }
        })
      }

      this.editinfo = row
      this.Isedit = true
      this.edit_dialogVisible = true
      if(row.yifangIds){
        this.checkList = row.yifangIds
      }
      this.getYiFangList()
    },
    // 打开添加弹窗
    add() {
      this.editinfo = {}
      this.Isedit = false
      this.edit_dialogVisible = true
      this.checkList = []
      this.getYiFangList()
    },
    // 更新信息
    updateInfo() {
      var MYArray = []
      // console.log("this.authority_form",this.authority_form)
      this.authority_form.forEach((AuItems) => {
        // console.log("AuItems",AuItems)
        AuItems.checkedItem.forEach((item) => {
          MYArray.push(item.value)
        })
      })
      // 特殊权限遍历
      var _permissions = []
      this.permissions_from.checkedItem.forEach((item) => {
        _permissions.push(item.value)
      })
      // 更新权限
      if (this.Isedit) {
        console.log(1,this.editinfo)
        // console.log("MYArray",MYArray)
        this.editinfo.authorities = MYArray.toString()
        this.editinfo.permissions = _permissions.toString()
        if (MYArray.length == 0 && _permissions.length == 0) {
          return this.$message.error('你不能把改角色的权限全部删除')
        }
        if (
          this.editinfo.permissions.includes(
            'permission:singlePushMessageRecorde'
          )
        ) {
          this.editinfo.authorities += ',admin:singlePushMessageRecorde'
        }
        if (this.editinfo.permissions.includes('permission:kefuonline')) {
          this.editinfo.authorities += ',admin:kefuMessage'
        }
        // 如果选了用户管理权限，追加用户管理查看聊天的权限
        if (this.editinfo.permissions.includes('permission:userChat')) {
          this.editinfo.authorities += ',admin:messageRoute'
        }
        //  if (this.editinfo.permissions.includes("permission:kefuonline")) {
        //   this.editinfo.authorities += ",admin:chatRecord";
        // }
        if (this.editinfo.permissions.includes('permission:dangerChat')) {
          this.editinfo.authorities += ',admin:hitChatMessage'
        }
        // console.log("this.editinfo.authorities")
        // console.log(this.editinfo.authorities)
        // console.log("this.editinfo.permissions")
        // console.log(this.editinfo.permissions)
        // this.editinfo.permissions.includes()
        // console.log("this.editinfo",this.editinfo)
        this.editinfo.yifangIds = this.checkList.join(',')
        this.$api.role
          .UpdataRole(this.editinfo)
          .then((res) => {
            this.$message.success(res)
            this.getRoleinfo()
            this.edit_dialogVisible = false
          })
          .catch((err) => {
            this.$message.error(err || '服务器错误，请稍后重试')
          })
      } else {
        // 添加角色权限
        // if (!this.editinfo.name || !this.editinfo.description) {
        //   return this.$message.error("请填写角色名和角色描述");
        // }
        console.log(1,this.editinfo)
        if (MYArray.length == 0 && _permissions.length == 0) {
          return this.$message.error('你还没有为该角色添加权限')
        }
        this.editinfo.authorities = MYArray.toString()
        this.editinfo.permissions = _permissions.toString()
        // 如果选了用户管理权限，追加用户管理查看聊天的权限
        if (this.editinfo.permissions.includes('permission:userChat')) {
          if (this.editinfo.authorities.length == 0) {
            this.editinfo.authorities += 'admin:messageRoute'
          } else {
            this.editinfo.authorities += ',admin:messageRoute'
          }
        }
        if (this.editinfo.permissions.includes('permission:kefuonline')) {
          if (this.editinfo.authorities.length == 0) {
            this.editinfo.authorities += 'admin:kefuMessage'
          } else {
            this.editinfo.authorities += ',admin:kefuMessage'
          }
        }
        //    if (this.editinfo.permissions.includes("permission:kefuonline")) {
        //   if (this.editinfo.authorities.length == 0) {
        //     this.editinfo.authorities += "admin:chatRecord";
        //   } else {
        //     this.editinfo.authorities += ",admin:chatRecord";
        //   }
        // }
        if (this.editinfo.permissions.includes('permission:dangerChat')) {
          if (this.editinfo.authorities.length == 0) {
            this.editinfo.authorities += 'admin:hitChatMessage'
          } else {
            this.editinfo.authorities += ',admin:hitChatMessage'
          }
        }
        // console.log(this.editinfo)
        this.editinfo.yifangIds = this.checkList.join(',')
        this.$api.role
          .addRole(this.editinfo)
          .then((res) => {
            this.getRoleinfo()
            this.$message.success(res)
            this.edit_dialogVisible = false
          })
          .catch((err) => {
            this.$message.error(err || '服务器错误，请稍后重试')
          })
      }
    },
    // 全选权限
    handleCheckAllChange(index, checkAll) {
      this.authority_form[index].checkedItem = checkAll
        ? this.authority_form[index].Items
        : []
      this.authority_form[index].isIndeterminate = false
    },
    // 改变权限
    handleCheckedCitiesChange(index, items) {
      const checkedCount = items.length
      this.authority_form[index].checkAll =
        checkedCount === this.authority_form[index].Items.length
      this.authority_form[index].isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.authority_form[index].Items.length
    },
    // 全选特殊权限
    SPCheckAllChange(checkAll) {
      this.permissions_from.checkedItem = checkAll
        ? this.permissions_from.Items
        : []
      this.permissions_from.isIndeterminate = false
    },
    // 改变特殊权限
    SPCheckedCitiesChange(items) {
      const checkedCount = items.length
      this.permissions_from.checkAll =
        checkedCount === this.permissions_from.Items.length
      this.permissions_from.isIndeterminate =
        checkedCount > 0 && checkedCount < this.permissions_from.Items.length
    },
    // 打开删除对话框
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info('你并没有选中任何角色')
      }
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.handleDel()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 获取权限列表
    getpermissions() {
      var permissions = []
      const _asyncRoutes = asyncRoutes.slice(0, asyncRoutes.length-1)
      _asyncRoutes.forEach((item) => {
        console.log(item)
        var temp = {
          name: item.meta.title,
          checkAll: false,
          checkedItem: [],
          isIndeterminate: true,
          Items: []
        }
        item.children.forEach((item2) => {
          var temp2 = {
            label: item2.meta.title,
            value: item2.meta.roles[0]
          }
          temp.Items.push(temp2)
        })
        permissions.push(temp)
      })
      this.authority_form = permissions
      // console.log("permissions",permissions)
    }
  }
}
</script>
<style lang="scss">
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;

  .role_heard_tool {
    margin-bottom: 10px;
  }

  .edit_titile {
    .dialog_input {
      display: flex;
      align-items: center;
      // justify-content: space-around;
      width: 70%;

      .el-input {
        width: 70%;
      }
    }
  }

  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }

  .authority_info {
    margin-top: 25px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff;
    font-size: 26px;
    border: 1px solid #909399;
    border-radius: 25px;
    background: #c0c4cc;
    padding: 2px;
  }
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
</style>
